export default "__VITE_ASSET__002de211__"